<template>
    <v-flex>
        <v-btn v-on:click="resend"><v-icon>send</v-icon> Resend</v-btn>
    </v-flex>
</template>

<script>
/**
 * Triggers a request to the server to update this room type
 */
export default {
    name: 'ies-resend-sent-email',
    props: ['field', 'value'],
    data () {
        return {
        }
    },

    methods: {
        resend: function(event){
            this.preventParentBehaviour(event);

            var url = "/api/messaging/email/resend-sent?id=" + this.value;
            axios.get(url)
            .then(function(response){
                console.log(response);
                alert("Done");
            }.bind(this));
        },

        /**
         * Attempt to prevent default behaviours in parent components
         */
        preventParentBehaviour: function(e){
            console.log(e);
            //e.preventDefault();
            e.stopPropagation();    
        }
    }
}
</script>
